/* MKPBR 01/10/2026 - OFERTA "+1 UNIDADE COM 30%" no botao Finalizar compra do carrinho lateral.
   Pedido do Rafael: carrinho com 2+ itens -> ao clicar em Finalizar compra, oferece mais 1 unidade do item
   mais barato (preco cheio da unidade) com 30% de desconto. So os 30%: a faixa do Pumper NAO soma por cima.

   COMO O DESCONTO E DADO (sem produto gemeo, sem SKU novo):
   - a unidade extra entra na mesma linha do carrinho; a faixa do Pumper (5/10/15%) ja da parte do desconto;
   - o que falta para chegar a 30% vira um cupom de pedido com valor fixo, aplicado sozinho pelo script.
     Cupons: 2NDUNIT30-0025 ... 2NDUNIT30-1800 (US$ 0,25 a US$ 18,00, de 25 em 25 centavos; valor em dolar,
     a Shopify converte pela taxa do mercado). Cada um exige subtotal minimo de 10x o valor. Combinam com
     descontos de produto (Pumper, Weekly Picks) e de frete; NAO combinam com outro cupom de pedido.
   NAO OFERECE quando: carrinho com menos de 2 itens; ja existe cupom no carrinho (ILOVEMKPBR, afiliado...);
   item mais barato acima de US$ 60; a faixa do Pumper sozinha ja daria 30% ou mais; moeda sem taxa;
   ja mostrou nesta visita; cupom nao aplicou (desfaz tudo e segue para o pagamento sem a oferta).
   Se o cliente tirar a unidade extra depois, o script tira o cupom.
   Depende de window.MKCD (assets/mkpbr-cdrw.js). Textos: chaves ut/us/ul/uy/un/uc/ue em snippets/mkpbr-cdrw-t1..t3. */
(function(){
  'use strict';
  var D = document, W = window;
  var PCT = 30, MAX_USD = 6000, STEP = 25, MAX_CUPOM = 1800, MINX = 10, PFX = '2NDUNIT30-';
  var SEEN = 'mk2u_seen', MEM = 'mk2u';
  function boot(){
    var M = W.MKCD; if (!M || M.__2u) return; M.__2u = 1;
    var tr = M.t, esc = M.esc, MF = M.MF;
    function ss(k, v){
      try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {}
      return null;
    }
    function memo(){ try { return JSON.parse(ss(MEM) || 'null'); } catch (e) { return null; } }
    function rate(c){
      var s = W.Shopify && W.Shopify.currency; if (!s || !s.rate) return null;
      if (s.active && c.currency && s.active !== c.currency) return null;
      var r = parseFloat(s.rate); return r > 0 ? r : null;
    }
    /* cupons presentes no carrinho (em maiusculas) e se cada um esta valendo */
    function codes(c){
      var o = {};
      (c.discount_codes || []).forEach(function(d){ if (d && d.code) o[String(d.code).toUpperCase()] = !!d.applicable; });
      (c.cart_level_discount_applications || []).forEach(function(a){ if (a.type === 'discount_code' && a.title) { var k = String(a.title).toUpperCase(); o[k] = o[k] || (a.total_allocated_amount || 0) > 0; } });
      (c.items || []).forEach(function(it){ (it.line_level_discount_allocations || []).forEach(function(x){ var a = x.discount_application || {}; if (a.type === 'discount_code' && a.title) o[String(a.title).toUpperCase()] = true; }); });
      return o;
    }
    function isTier(a){ return /^buy \d/i.test((a.discount_application && a.discount_application.title) || ''); }
    function within(p, ms, v){ return Promise.race([p, new Promise(function(r){ setTimeout(function(){ r(v); }, ms); })]); }
    function props(x){ try { return JSON.stringify(x.properties || {}); } catch (e) { return ''; } }
    /* acha a linha do item: mesma chave; senao mesma variante + mesmas propriedades (+ quantidade, se pedida) */
    function findLine(c, it, key, qty){
      var items = (c && c.items) || [], i;
      for (i = 0; i < items.length; i++) if (items[i].key === key && (qty == null || items[i].quantity === qty)) return items[i];
      for (i = 0; i < items.length; i++) { var x = items[i]; if (x.variant_id === it.variant_id && props(x) === props(it) && (qty == null || x.quantity === qty)) return x; }
      return null;
    }
    /* subtotal dos itens com +1 unidade na linha "key": a faixa do Pumper vale para o carrinho todo e cada linha
       fica com o maior desconto de produto (faixa x Weekly Picks) - mesma conta do "Pague menos frete" */
    function simPlus1(c, key){
      var t = M.tierFor(c.item_count + 1) / 100, tot = 0;
      c.items.forEach(function(it){
        var o = it.original_line_price, dl = 0, tier = true;
        (it.line_level_discount_allocations || []).forEach(function(a){ dl += a.amount; if (!isTier(a)) tier = false; });
        /* linha sem desconto nenhum com 2+ itens = produto fora da faixa: continua sem desconto */
        var none = !(it.line_level_discount_allocations || []).length;
        var r = none ? 0 : (tier ? t : Math.max(o > 0 ? dl / o : 0, t));
        if (it.key === key) o += it.original_price;
        tot += Math.round(o * (1 - r));
      });
      return tot;
    }
    function plan(c){
      if (!c || c.item_count < 2 || ss(SEEN)) return null;
      var r = rate(c); if (!r) return null;
      if (Object.keys(codes(c)).length) return null;                 /* ja tem cupom: nao troca o do cliente */
      var it = null;
      c.items.forEach(function(x){
        if (x.gift_card || x.selling_plan_allocation || !(x.original_price > 0)) return;
        if (!it || x.original_price < it.original_price) it = x;
      });
      if (!it || it.original_price / r > MAX_USD) return null;
      var p = it.original_price, before = c.items_subtotal_price, after = simPlus1(c, it.key);
      var extra = after - before, target = Math.round(p * (100 - PCT) / 100), falta = extra - target;
      if (falta <= 0) return null;                                   /* a faixa sozinha ja da 30% ou mais: nao oferece (combinado com o Rafael) */
      var cup = Math.ceil(falta / r / STEP - 1e-9) * STEP;
      if (cup > MAX_CUPOM) return null;
      if (after < MINX * cup * r * 1.02) return null;                /* nao alcancaria o minimo do cupom */
      return { it: it, p: p, pay: target, pct: PCT, code: PFX + ('000' + cup).slice(-4), cup: cup, r: r, base: c.total_price };
    }

    /* ---------- popup ---------- */
    function popup(c, o){
      return new Promise(function(resolve){
        var it = o.it, vt = (it.product_has_only_default_variant || !it.variant_title) ? '' : ' · ' + it.variant_title;
        var s0 = M.shipState(c), s1 = M.shipState({ total_price: c.total_price + o.pay, item_count: c.item_count + 1, currency: c.currency }), ship = '';
        if (s0 && s1 && !s0.calculado && !s1.calculado && s0.freteAtual != null && s1.freteAtual != null && s1.freteAtual < s0.freteAtual) {
          var a = Math.round(s0.freteAtual * 100), b = Math.round(s1.freteAtual * 100);
          ship = '<div class="mkcp__deal">' + esc(b === 0 ? tr('lfree') : tr('ldrop', { a: MF(a), b: MF(b) })) + '</div>';
        }
        var box = D.createElement('div'); box.className = 'mkcp mk2u'; if (M.rtl) box.setAttribute('dir', 'rtl');
        box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-labelledby', 'mk2u-h');
        box.innerHTML = '<button class="mkcp__veil" type="button" tabindex="-1" aria-label="' + esc(tr('close')) + '" data-x></button><div class="mkcp__box">' +
          '<button class="mkcp__x" type="button" aria-label="' + esc(tr('close')) + '" data-x>&times;</button>' +
          '<p class="mkcp__eye" id="mk2u-h">' + esc(tr('ut')) + '</p><p class="mkcp__sub">' + esc(tr('us', { p: PCT })) + '</p>' +
          '<div class="mkcp__card is-offer"><span class="mkcd__img">' + (it.image ? '<img src="' + esc(M.sizeImg(it.image, 160)) + '" alt="" width="64" height="64">' : '') + '</span>' +
          '<div><div class="mkcp__lbl">' + esc(tr('ul', { p: o.pct })) + '</div><div class="mkcd__ttl">' + esc(it.product_title + vt) + '</div>' +
          '<div class="mkcp__pr"><s>' + MF(o.p) + '</s> ' + MF(o.pay) + ' <span class="mk2u__off"><bdi dir="ltr">−' + o.pct + '%</bdi></span></div></div></div>' +
          ship +
          '<button class="mkcp__yes" type="button" data-yes>' + esc(tr('uy', { x: MF(o.pay) })) + '</button>' +
          '<button class="mkcp__no" type="button" data-no>' + esc(tr('un')) + '</button>' +
          '<p class="mk2u__note">' + esc(tr('uc')) + '</p></div>';
        D.body.appendChild(box);
        var yes = box.querySelector('[data-yes]'), no = box.querySelector('[data-no]'), last = D.activeElement, busy = false;
        setTimeout(function(){ try { yes.focus({ preventScroll: true }); } catch (e) {} }, 30);
        M.pub('mkpbr_2u_offer', { action: 'show', pct: o.pct, code: o.code });
        var fin = function(v){ D.removeEventListener('keydown', onKey); if (box.parentNode) box.parentNode.removeChild(box); try { if (!v && last && last.focus) last.focus({ preventScroll: true }); } catch (e) {} resolve(v); };
        var fail = function(){
          busy = false; yes.hidden = true; no.disabled = false; yes.classList.remove('is-loading');
          var p = D.createElement('p'); p.className = 'mkcp__err'; p.textContent = tr('ue'); no.parentNode.insertBefore(p, no);
          M.pub('mkpbr_2u_offer', { action: 'fail', code: o.code });
        };
        var accept = function(){
          busy = true; yes.disabled = true; no.disabled = true; yes.classList.add('is-loading');
          var q = it.quantity, key = it.key;
          var post = function(path, body){ return M.api(path, { method: 'POST', body: JSON.stringify(body) }); };
          var read = function(){ return M.api('cart.js', { method: 'GET', cache: 'no-store' }); };
          /* desfaz: tira o cupom, volta a linha para a quantidade de antes e CONFERE. true = carrinho como estava */
          var undo = function(){
            return post('cart/update.js', { discount: '' }).catch(function(){}).then(read).then(function(c){
              var ln = findLine(c, it, key, q + 1);
              if (!ln) return !!findLine(c, it, key, q);
              return post('cart/change.js', { id: ln.key, quantity: q }).then(read).then(function(c2){ return !!findLine(c2, it, key, q) && !findLine(c2, it, key, q + 1); });
            }).catch(function(){ return false; });
          };
          var tol = Math.max(2, Math.round(o.p * 0.005));
          within(post('cart/change.js', { id: key, quantity: q + 1 }).then(function(c1){
            if (!findLine(c1, it, key, q + 1)) throw new Error('qty');
            return post('cart/update.js', { discount: o.code }).then(read);
          }).then(function(c2){
            if (!codes(c2)[o.code]) throw new Error('code');
            /* confere o que o cliente paga a mais de verdade: nem acima do preco mostrado, nem abaixo de 30% + arredondamento */
            var inc = c2.total_price - o.base;
            if (inc > o.pay + tol || inc < o.pay - Math.ceil(STEP * o.r) - tol) throw new Error('price ' + inc);
            return c2;
          }), 15000, null).then(function(c3){
            if (!c3) throw new Error('timeout');
            ss(MEM, JSON.stringify({ code: o.code, v: it.variant_id, q: q + 1 }));
            M.pub('mkpbr_2u_offer', { action: 'yes', pct: o.pct, code: o.code });
            return M.refresh().catch(function(){}).then(function(){ fin(true); });
          }).catch(function(err){
            if (W.console) console.warn('[mk2u]', err && err.message);
            undo().then(function(ok){
              M.refresh().catch(function(){});
              if (ok) fail();
              else { M.pub('mkpbr_2u_offer', { action: 'fail', code: o.code }); fin(false); }   /* nao deu para confirmar: fica no carrinho, que mostra o que esta la */
            });
          });
        };
        var onKey = function(e){ if (e.key === 'Escape' && !busy) { M.pub('mkpbr_2u_offer', { action: 'close' }); fin(false); } };
        D.addEventListener('keydown', onKey);
        box.addEventListener('click', function(e){
          if (busy) return;
          if (e.target.closest('[data-yes]')) accept();
          else if (e.target.closest('[data-no]')) { M.pub('mkpbr_2u_offer', { action: 'no', code: o.code }); fin(true); }
          else if (e.target.closest('[data-x]')) { M.pub('mkpbr_2u_offer', { action: 'close' }); fin(false); }
        });
      });
    }

    /* Finalizar compra: pergunta antes de ir para o checkout. true = segue; false = fica no carrinho */
    M.hooks.beforeCheckout.push(function(){
      return within(M.refresh(), 5000, null).then(function(c){
        var o = plan(c); if (!o) return true;
        ss(SEEN, '1');
        return popup(c, o);
      }).catch(function(){ return true; });
    });

    /* cliente tirou a unidade extra depois de aceitar -> tira o cupom (o desconto era so para ela) */
    M.hooks.render.push(function(c){
      var m = memo(); if (!m) return;
      var cs = codes(c); if (!(m.code in cs)) { ss(MEM, null); return; }
      var q = 0; c.items.forEach(function(x){ if (x.variant_id === m.v) q += x.quantity; });
      if (q >= m.q) return;
      ss(MEM, null);
      var rest = Object.keys(cs).filter(function(k){ return k !== m.code; }).join(',');
      M.api('cart/update.js', { method: 'POST', body: JSON.stringify({ discount: rest }) }).then(function(){ return M.refresh(); }).catch(function(){});
    });
  }
  if (W.MKCD) boot(); else D.addEventListener('mkcd:ready', boot);
})()